// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"cb90b2a1d8c54537c8a0","655":"e6813f74de0e50f27489"}[chunkId] + ".js";
};